import { render, staticRenderFns } from "./CmsFieldsCategorySelector.vue?vue&type=template&id=54bd47c7&scoped=true"
import script from "./CmsFieldsCategorySelector.vue?vue&type=script&lang=ts"
export * from "./CmsFieldsCategorySelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bd47c7",
  null
  
)

export default component.exports